import styled from 'styled-components';
import { rem } from '../../utils/functions.js';
import { typography } from '../../typography/typography.js';

var Root = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__Root",
  componentId: "sc-1p95loh-0"
})(["font-family:", ";font-size:", ";color:", ";position:relative;width:295px;", ""], typography.fontFamily, typography.fontSize, function (_ref) {
  var theme = _ref.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_1;
}, function (_ref2) {
  var rootStyle = _ref2.rootStyle;
  return rootStyle;
});
process.env.NODE_ENV !== "production" ? Root.displayName = 'Root' : void 0;
var InputAndToggle = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__InputAndToggle",
  componentId: "sc-1p95loh-1"
})(["position:relative;"]);
process.env.NODE_ENV !== "production" ? InputAndToggle.displayName = 'InputAndToggle' : void 0;
var TogglePicker = /*#__PURE__*/styled.button.withConfig({
  displayName: "styledComponents__TogglePicker",
  componentId: "sc-1p95loh-2"
})(["position:absolute;bottom:4px;right:-1px;height:calc(", " - 2px);background:transparent;border:none;padding:10px;cursor:", ";"], rem(46), function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled ? 'auto' : 'pointer';
});
process.env.NODE_ENV !== "production" ? TogglePicker.displayName = 'TogglePicker' : void 0;
var Picker = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__Picker",
  componentId: "sc-1p95loh-3"
})(["display:block;line-height:", ";position:absolute;box-sizing:border-box;width:395px;box-shadow:0 2px 5px rgba(0,0,0,0.15);background:", ";padding:20px;z-index:99;", ""], typography.lineHeight, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colorPalette.neutralColors.light.shade_white;
}, function (_ref5) {
  var pickerStyle = _ref5.pickerStyle;
  return pickerStyle;
});
process.env.NODE_ENV !== "production" ? Picker.displayName = 'Picker' : void 0;
var Header = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__Header",
  componentId: "sc-1p95loh-4"
})(["display:flex;justify-content:space-between;align-items:center;font-size:", ";font-weight:600;margin-bottom:20px;"], rem(18));
process.env.NODE_ENV !== "production" ? Header.displayName = 'Header' : void 0;
var Table = /*#__PURE__*/styled.table.withConfig({
  displayName: "styledComponents__Table",
  componentId: "sc-1p95loh-5"
})(["width:100%;text-align:center;font-weight:300;& th{font-size:", ";font-weight:600;cursor:help;& abbr{border-bottom:none;cursor:inherit;text-decoration:none;}}"], typography.fontSize);
process.env.NODE_ENV !== "production" ? Table.displayName = 'Table' : void 0; // Styled components for Td

var determineBorderColor = function determineBorderColor(isFocused, isCurrentDate, theme, selected) {
  if (isFocused) {
    return theme.colorPalette.primaryColors.main.shade_dark_1;
  }

  if (isCurrentDate) {
    return theme.colorPalette.neutralColors.light.shade_dark_1;
  }

  if (selected) {
    return theme.colorPalette.neutralColors.light.shade_white;
  }

  return 'transparent';
};

var StyledTd = /*#__PURE__*/styled.td.withConfig({
  displayName: "styledComponents__StyledTd",
  componentId: "sc-1p95loh-6"
})(["cursor:", ";border-style:solid;padding:5px;outline:none;border:1.5px solid transparent;border-color:", ";color:", ";background-color:", ";box-sizing:border-box;&:hover{background-color:", ";}"], function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (_ref6) {
  var isFocused = _ref6.isFocused,
      isCurrentDate = _ref6.isCurrentDate,
      theme = _ref6.theme,
      selected = _ref6.selected;
  return determineBorderColor(isFocused, isCurrentDate, theme, selected);
}, function (props) {
  if (props.selected) {
    return props.theme.colorPalette.neutralColors.light.shade_white;
  }

  if (props.disabled) {
    return props.theme.colorPalette.neutralColors.light.shade_dark_3;
  }

  return props.theme.colorPalette.neutralColors.dark.shade_light_1;
}, function (props) {
  if (props.selected) {
    return props.theme.colorPalette.primaryColors.main.shade_dark_1;
  }

  return 'transparent';
}, function (props) {
  if (props.selected) {
    return props.theme.colorPalette.primaryColors.main.shade_dark_1;
  }

  if (props.disabled) {
    return props.theme.colorPalette.neutralColors.light.shade_white;
  }

  return props.theme.colorPalette.primaryColors.main.shade_light_4;
});
process.env.NODE_ENV !== "production" ? StyledTd.displayName = 'StyledTd' : void 0; // Styled components for MonthToggle

var ToggleButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "styledComponents__ToggleButton",
  componentId: "sc-1p95loh-7"
})(["background:", ";border:none;padding:10px;cursor:", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colorPalette.neutralColors.light.shade_white;
}, function (_ref8) {
  var disabled = _ref8.disabled;
  return disabled ? 'normal' : 'pointer';
});
process.env.NODE_ENV !== "production" ? ToggleButton.displayName = 'ToggleButton' : void 0;
var SmallText = /*#__PURE__*/styled.span.withConfig({
  displayName: "styledComponents__SmallText",
  componentId: "sc-1p95loh-8"
})(["font-family:", ";font-weight:", ";color:", ";"], typography.fontFamily, typography.fontWeightLight, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_3;
});
process.env.NODE_ENV !== "production" ? SmallText.displayName = 'SmallText' : void 0;

export { Header, InputAndToggle, Picker, Root, SmallText, StyledTd, Table, ToggleButton, TogglePicker };
